import { Tabs } from 'antd';
import styled from 'styled-components';

export const TabsContainer = styled(Tabs)`
  .ant-tabs-nav-wrap {
    margin-top: 8px;
    margin-bottom: 16px;
  }
`;
